// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentsContainer_root__i9YH2","title":"AttachmentsContainer_title__23dDD"};